import * as React from "react";
import {cx, css}  from "emotion";
import {Link}     from "react-router-dom";
import {rgba}     from "polished";

import "./product-tiles.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {keyed}          from "@Common/react/keyed";
import {rLsStore}       from "@Common/react/ls-store";
import {Types}          from "@Common/types";
import {Responsive}     from "@Common/ui-components/responsive";

import {Tooltip}          from "../../../common/tool-tip";
import {FlexInternalLink} from "../components/flex-internal-link";

import {rLineTiles}       from "./line-tiles/line-tiles";
import {rTilesViewConfig} from "./view-config/tiles-view-config";

export const rProductTiles = ({
    products,
    getProductViewData,
    view_more
}:{
    products : any[],
    getProductViewData: (item: any) => Types.Xpresso.Common.Tiles.Product
    view_more: {
        getItems: (product: any) => any,
        renderItem,
        alwaysShow?: boolean,
    },
}) => cs(
    // @ts-ignore
    ["responsive", (_, next) => <Responsive {...{
        sizes: {
            md: 1024,
            lg: 1920,
        },
        next,
    }}/>],
    ["viewMode", ({responsive}, next) => responsive.lt("md") ? next({value: "large"}) : rLsStore("tiles.viewMode2", "medium")({}, next)],
    consumeContext("themeScheme"),
    ({viewMode, responsive, themeScheme}) => (
        <div className={cx("product-tiles product-tiles-1j4", viewMode.value)}>

            <Tooltip />

            {responsive.ge("md") && (
                <div className="tiles-view-config">
                    {rTilesViewConfig(viewMode)}
                </div>
            )}

            <div className="tiles">
                {rLineTiles<Types.Xpresso.Common.Tiles.Product>({
                    items: products.map(getProductViewData),
                    viewMode: viewMode.value,
                    renderItem: ({item, viewMore}) => (
                        <div className="product-tiles-item-4zv" xd-qa-type="tile">
                            {FlexInternalLink({
                                href: item.href,
                                to: item.to,
                                target: item.new_tab?"_blank":undefined,
                                className: "clicker",
                            })}
                            <div className="background">
                                <div
                                    className="img"
                                    style={{
                                        backgroundImage: `url(${item.img_url.replace(/ /g, '%20').replace(/\(/g, '%28').replace(/\)/g, '%29')})`,
                                    }}
                                />
                                {( item.type == "subscriber" && item.children.length > 0 ) && <div
                                className="subscriber"
                                style={{
                                    backgroundImage: `url("/next_images/XDPlusTileBanner.svg")`,
                                }}
                            />}
                            </div>
                            <div className="bottom">
                                <div
                                    className={cx("name", {padding: !!item?.getIcon()})}
                                    style={{
                                        background: themeScheme.xpresso.tileLabelColor,
                                        color: themeScheme.xpresso.tileLabelTextColor,
                                    }}
                                >
                                    {item.name.toUpperCase()}
                                    {item?.getIcon()}
                                </div>
                                <div
                                    className="details"
                                    style={{
                                        background: rgba(themeScheme.xpresso.tileLabelColor, 0.8),
                                    }}
                                >
                                    <div className="lines">
                                        {item.children.slice(0, 3).map((child, i) => cs(
                                            keyed(i),
                                            () => (
                                                FlexInternalLink({
                                                    href: child.href,
                                                    target: child.new_tab?"_blank":undefined,
                                                    to: child.to,
                                                    className: "line",
                                                    style: {color: themeScheme.xpresso.tileLabelTextColor,},
                                                    "data-tip": child.name,
                                                    "xd-qa-type": "link",
                                                    "xd-qa-name": child.name,
                                                    children: child.name,
                                                })
                                            ),
                                        ))}
                                    </div>

                                    {( item.children.length > 3 || ( !!item.children.length && view_more.alwaysShow ) ) && (
                                        <div
                                            className={cx("view-more", css`
                                            `)}
                                            xd-qa-type="button"
                                            xd-qa-name={!viewMore.value ? (
                                                "VIEW MORE"
                                            ) : (
                                                "CLOSE"
                                            )}
                                            onClick={() => viewMore.onChange(!viewMore.value)}
                                        >
                                            {!viewMore.value ? (
                                                "VIEW MORE"
                                            ) : (
                                                "CLOSE"
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ),
                    getViewMoreItems: (index) => view_more.getItems(products[index]),
                    renderViewMoreItem: (vmItem, index) => view_more.renderItem(vmItem, {viewMode: viewMode.value, parent: products[index]}),
                })}
            </div>
        </div>
    ),
);
